import { HolidayReportController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Shows holiday report of selected holiday year
 * @example
 * ```html
 * <salaxy-holiday-report></salaxy-holiday-report>
 * ```
 */
export class HolidayReport extends ComponentBase {

   /**
    * The following component properties (attributes in HTML) are bound to the Controller.
    * For detailed functionality, refer to [controller](#controller) implementation.
    */
    public bindings = {};

    /** Uses the HolidayReportController */
    public controller = HolidayReportController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/report/HolidayReport.html";

}
